import { TFormalOffer } from '@helpers/FormalOffers/formalOffers.types';
import { getOfferInterestRate } from '@helpers/FormalOffers/getOfferInterestRate';
import { Text } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import { VariableRate } from '../../../../../../../ui/rate';

export const InterestRateRow = ({
    selectedOffer
}: {
    selectedOffer: TFormalOffer | undefined;
}) => {
    const interestRate = selectedOffer
        ? getOfferInterestRate(selectedOffer)
        : null;

    return (
        <div className="flex items-center justify-between">
            <Text>
                <FormattedMessage
                    id="_.loan_summary.interest_rate"
                    defaultMessage="Interest rate /30 days:"
                />
            </Text>
            <Text className="font-bold">
                {interestRate !== null ? (
                    <VariableRate
                        minimumFractionDigits={2}
                        maximumFractionDigits={3}
                        value={interestRate}
                    />
                ) : (
                    '--,-- %'
                )}
            </Text>
        </div>
    );
};
